import { BrainCircuit, Code2, ShieldCheck, Megaphone, Building2, UsersRound, BookOpen, FolderKanban, ClipboardList, Workflow, Rocket } from 'lucide-react';

export const workLinks = [
  { label: 'AI & Automation', to: '/services#ai-automation', id: 'ai-automation', icon: BrainCircuit, description: 'Strategy to production AI, built around outcomes' },
  { label: 'AI Automation', to: '/services#ai-automation', id: 'ai-automation-focus', icon: Workflow, description: 'Automate manual workflows with agents and intelligent document processing' },
  { label: 'Software & Digital Products', to: '/services#software-digital-products', id: 'software-digital-products', icon: Code2, description: 'Web, mobile and platform engineering' },
  { label: 'Enterprise Technology', to: '/services#enterprise-technology', id: 'enterprise-technology', icon: ShieldCheck, description: 'Managed IT, cloud, security and data' },
  { label: 'Digital Transformation', to: '/services#enterprise-technology', id: 'digital-transformation', icon: Rocket, description: 'Modernise legacy systems, data and ways of working' },
  { label: 'Digital Growth', to: '/services#digital-growth', id: 'digital-growth', icon: Megaphone, description: 'Brand, marketing and demand generation' },
];

export const resourceLinks = [
  { label: 'Blog', to: '/blog', id: 'blog', icon: BookOpen },
  { label: 'Case Studies', to: '/case-studies', id: 'case-studies', icon: FolderKanban },
  { label: 'Intake Form', to: '/intake-form', id: 'intake-form', icon: ClipboardList },
];

export const companyLinks = [
  { label: 'About', to: '/about', id: 'about', icon: Building2 },
  { label: 'Our Team', to: '/our-team', id: 'our-team', icon: UsersRound },
];

export const policyLinks = [
  { label: 'Privacy Policy', to: '/privacy-policy', id: 'privacy-policy' },
  { label: 'Terms', to: '/terms', id: 'terms' },
  { label: 'Cookie Policy', to: '/cookie-policy', id: 'cookie-policy' },
  { label: 'Accessibility', to: '/accessibility', id: 'accessibility' },
];
